module.exports = __webpack_public_path__ + "img/send_email.267abb81.svg";